// import client from '@/apis/http-client'
// import Vue from 'vue'

// ========================================================================
// TODO: Remove mocking data and helper
// function when fully implemented.
import client from '@/apis/http-client'
import Vue from 'vue'
let pathUrl = `/por/api`
// const pathOrgUrl = `por/api/organization?page_size=1000`
const pathOrgUrl = `por/api/organization/permission`
import {
  convertDatePicker,
  convertFileToBase64,
  splitToDateAndTime
} from '../helper/helper'
import qs from 'qs'
import moment from 'moment'

// End: TODO
// ========================================================================

// Initial state.
const defaultState = () => {
  return {
    // Filters
    orgList: {
      all: [],
      selected: []
    },
    promotionOnly: false,
    filterStatus: '',
    filterCategory: '',
    textSearch: '',
    deleteId: 0,
    isDelete: false,
    // List of news
    category: [],
    isDisableAfterPublish: false,
    isLoading: false,
    newsList: [],
    updateIdList: [],
    isPreview: false,
    currentPage: 1,
    pageSize: 25,
    total: 0,
    sortBy: 'update_date',
    sortDesc: 'DESC',
    orgObject: [],
    // news object
    newsObject: {
      id: null,
      orgs: [],
      category_id: 0,
      contents: [
        {
          code: 'th',
          title: null,
          description: '',
          thumbnail: ''
        },
        {
          code: 'en',
          title: null,
          description: '',
          thumbnail: ''
        }
      ],
      public_date: null,
      status: 0,
      doctor_id: null,
      is_featured: false,
      slug: '',
      meta: null,
      doctor_ids: [],
      department_ids: [],
      package_ids: [],
      campaign_ids: [],
      period_start_date: null,
      period_end_date: null,
      period_start_time: '',
      period_end_time: '',
      create_by_user: null,
      update_by_user: null
    },
    isEditMode: false,
    duplicateId: null,
    departmentList: [],
    doctorList: [],
    packageList: [],
    campaignList: [],
    isLoadingEntities: false,

    categoryTableList: [],
    categoryTotal: 0,
    categoryCurrentPage: 1,
    categoryPageSize: 10,
    isCategoryLoading: false,
  }
}

// State
let state = defaultState()

// Function
const transformDuplicate = (newsObject) => {
    delete newsObject['create_by']
    delete newsObject['update_by']
    delete newsObject['update_date']
    newsObject.contents = newsObject.contents.map(c => ({
      code: c.code,
      title: c.title,
      description: c.description,
      thumbnail: c.thumbnail
    }))
    return newsObject
}

// Actions
const actions = {
  async setOrgInfo({ commit }, isViewOnly) {
    commit('SET_IS_LOADING', true)

    let mode = ''
    if (isViewOnly) {
      mode = 'View'
    } else if (state.isEditMode) {
      mode = 'Edit'
    } else {
      mode = 'Add'
    }

    let data = await client.secureHttpClient.get(
      `${pathOrgUrl}?permission=${mode}&category=News`
    )
    commit('SET_IS_LOADING', false)
    commit('SET_ORG_LIST', data.data)
    commit('SET_ORG_FILTER', data.data)
  },
  async setListOrgInfo({commit}) {
    let data = await client.secureHttpClient.get(
      `${pathOrgUrl}?permission=View&category=News`
    )
    commit('SET_ORG_FILTER', data.data)
  },
  resetList({commit}) {
    commit('RESET_LIST_STATE')
  },
  setImageThai({commit}, file) {
    commit('SET_IMAGE_THAI', file)
  },
  setImageEng({commit}, file) {
    commit('SET_IMAGE_ENG', file)
  },
  resetState({commit}) {
    commit('RESET_STATE')
  },
  setEditMode({commit}, isEditable) {
    commit('SET_EDIT_MODE', isEditable)
  },
  setDeleteId({commit}, id) {
    commit('SET_DELETE_ID', id)
  },
  setPage({commit}, page) {
    commit('SET_PAGE', page)
  },
  setPageSize({commit}, size) {
    commit('SET_PAGE_SIZE', size)
  },
  setFilterStatus({commit}, status) {
    commit('SET_FILTER_STATUS', status)
  },
  setFilterCategory({commit}, status) {
    commit('SET_FILTER_CATEGORY', status)
  },
  setShowPreview({commit}, status) {
    commit('SET_SHOW_PREVIEW', status)
  },
  setTextSearch({commit}, text) {
    if (text == state.textSearch) return
    commit('SET_TEXT_SEARCH', text)
  },
  setFieldSort({commit}, field) {
    if (field) {
      commit('SET_FIELD_SORT', field)
    } else {
      commit('SET_FIELD_SORT', defaultState().sortBy)
    }
  },
  setSort({commit}, sort) {
    commit('SET_SORT', sort === undefined ? 'DESC' : sort ? 'DESC' : 'ASC')
  },
  setSelectedId({commit}, ids) {
    commit('SET_UPDATE_ID', ids)
  },
  setDeletePopup({commit}, status) {
    commit('SET_POPUP_DELETE', status)
  },
  setOrgFilterCategory({commit}, status) {
    commit('SET_ORG_FILTER_CATEGORY', status)
  },
  async setNewsId({ commit }, id) {
    commit('SET_IS_LOADING', true)
    try {
      let data = await client.secureHttpClient.get(`${pathUrl}/news/${id}`)
      commit('SET_NEWS', data.data)
      commit('SET_PERIODS', data.data)
      return data.data // ✅ Return data for direct usage
    } catch (e) {
      Vue.$log.error(e)
      return null
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },
  async setDuplicateNewsId({ commit }, id) {
    commit('SET_IS_LOADING', true)
    try {
      let data = await client.secureHttpClient.get(`${pathUrl}/news/${id}`)
      commit('SET_NEWS', {
        ...data.data,
        id: defaultState().newsObject.id,
        period_start_date: defaultState().newsObject.period_start_date,
        period_end_date: defaultState().newsObject.period_end_date,
        period_start_time: defaultState().newsObject.period_start_time,
        period_end_time: defaultState().newsObject.period_end_time,
      })
      return data.data
    } catch (e) {
      Vue.$log.error(e)
      return null
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },
  async setPreview({ commit }, id) {
    commit('SET_IS_LOADING', true)
    let data = await client.secureHttpClient.get(`${pathUrl}/news/${id}`)
    if (data) {
      commit('SET_NEWS', data.data)
      commit('SET_PERIODS', data.data)
      commit('SET_SHOW_PREVIEW', true)
    }
    commit('SET_IS_LOADING', false)
  },
  /// EDIT call
  async update({commit, dispatch}, status) {
    let ids = state.updateIdList.map(id => {
      return id.id
    })
    let body = {ids: ids, status: status}
    try {
      await client.secureHttpClient.patch(`${pathUrl}/news/bulk-update`, body)
      dispatch('fetch')
      commit('SET_UPDATE_ID', [])
      return true
    } catch (e) {
      dispatch('fetch')
      Vue.$log.error(e)
      return false
    }
  },
  async updateAllStatus({commit}, {ids, status}) {
    try {
      ids = ids.map(id => {
        return id.id
      })
      let body = {
        ids: ids,
        status: status
      }
      commit('SET_LOAD', true)
      await client.secureHttpClient.patch(`${pathUrl}/news/bulk-update`, body)
      commit('SET_LOAD', false)
      return true
    } catch (e) {
      commit('SET_LOAD', false)
      return false
    }
  },
  async upload(_, payload) {
    try {
      let data = await client.secureHttpClient.post(
        `${pathUrl}/uploadImage`,
        payload
      )
      return data.data.url
    } catch (e) {
      Vue.$log.error(e)
      return ''
    }
  },
  async deletePkg({commit, dispatch}) {
    try {
      commit('SET_IS_LOADING', true)
      await client.secureHttpClient.delete(`${pathUrl}/news/${state.deleteId}`)
      commit('SET_POPUP_DELETE', false)
      commit('SET_DELETE_ID', 0)
      dispatch('fetch')
      return true
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_LOADING', false)
      commit('SET_POPUP_DELETE', false)
      return false
    }
  },
  // API calls
  async fetch({commit}) {
    commit('SET_IS_LOADING', true)
    const {
      currentPage,
      pageSize,
      textSearch,
      filterStatus,
      sortBy,
      sortDesc,
      filterCategory,
      orgList
    } = state
    const params = {
      page: currentPage,
      limit: pageSize,
      q: textSearch ? textSearch.trim() : '',
      orderBy: sortBy || 'update_date',
      sort: sortDesc || 'DESC',
      status: (filterStatus !== 'all' && filterStatus !== '') ? filterStatus : '',
      ...(filterCategory && filterCategory !== 'all' && { category: filterCategory }),
      ...(orgList.selected.length > 0 && {
        orgs: orgList.selected.map(o => o.codename)
      })
    }
    try {
      const res = await client.secureHttpClient.get(`${pathUrl}/news`, {
        params,
        paramsSerializer: p => qs.stringify(p, { encode: false })
      })
      commit('SET_TOTAL', res.data.total || 0)
      commit('SET_NEWS_LIST', res.data.results || [])
    } catch (e) {
      Vue.$log.error(e)
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },
  setStyleImage({commit}) {
    commit('SET_STYLE_CONTENT')
  },

  async updatePkg({commit}, payload) {
    const {pkg, id} = payload
    commit('SET_IS_LOADING', true)
    try {
      let data = await client.secureHttpClient.put(`${pathUrl}/news/${id}`, pkg)
      commit('SET_IS_LOADING', false)
      return data.data.success
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_LOADING', false)
    }
  },
  async create({commit}, pkg) {
    commit('SET_IS_LOADING', true)
    try {
      // reset for duplicate case
      const newsObject = transformDuplicate(pkg)

      await client.secureHttpClient.post(`${pathUrl}/news/`, newsObject)
      commit('RESET_STATE')
      commit('SET_IS_LOADING', false)
      return true
    } catch (e) {
      Vue.$log.error(e)
      commit('SET_IS_LOADING', false)
      return false
    }
  },
  async fetchNews(
    {commit},
    {page, search, limit, status, category, sortBy, sortDesc}
  ) {
    try {
      commit('SET_LOAD', true)
      let queryString = `?page=${page}&&limit=${limit}&&q=${search}&&status=${status}&&category=${
        category[0].text
      }&orderBy=${sortBy[0] ? sortBy[0] : 'update_date'}&sort=${
        sortDesc[0] ? 'DESC' : 'ASC'
      }`
      let data = await client.secureHttpClient.get(
        `${pathUrl}/news${queryString}`
      )
      if (data.data) {
        commit('SET_DATA', data)
      }
      commit('SET_LOAD', false)
    } catch (e) {
      commit('SET_LOAD', false)
    }
  },
  async fetchCategory({commit}) {
    const {orgFilterCategory} = state
    try {
      let query = '?all_status=true'
      if (orgFilterCategory && orgFilterCategory.length > 0) {
        orgFilterCategory.forEach((org, index) => {
          query += `&orgs[${index}]=${org}`
        })
      }
      let category = await client.secureHttpClient.get(
        `${pathUrl}/category${query}`
      )
      commit('SET_CATEGORY', category)
    } catch (e) {
      commit('SET_CATEGORY', { data: [] })
    }
  },
  async fetchCategoryOnList({ commit }) {
    const { orgFilterCategory } = state
    try {
      let query = '?all_status=true'
      if (orgFilterCategory && orgFilterCategory.length > 0) {
        orgFilterCategory.forEach((org, index) => {
          query += `&orgs[${index}]=${org}`
        })
      }
      let category = await client.secureHttpClient.get(
        `${pathUrl}/category${query}`
      )
      commit('SET_CATEGORY', category)
    } catch (e) {
      commit('SET_CATEGORY', { data: [] })
    }
  },
  setDuplicateId({ commit }, id) {
    commit('SET_DUPLICATE_NEWS_ID', id)
  },
  async fetchMasterEntities({ commit }) {
    commit('SET_LOADING_ENTITIES', true)
    try {
      const [deptRes, docRes, pkgRes, bannerRes] = await Promise.all([
        client.secureHttpClient.get(`${pathUrl}/departmentlist`).catch(() => null),
        client.secureHttpClient.get(`${pathUrl}/doctors`, { params: { page: 1, limit: 100 } }).catch(() => null),
        client.secureHttpClient.get(`${pathUrl}/package`, { params: { page: 1, limit: 50, status: 0 } }).catch(() => null),
        client.secureHttpClient.get(`${pathUrl}/banner`, { params: { page: 1, limit: 50, status: 0 } }).catch(() => null)
      ])

      const departments = (deptRes?.data && (deptRes.data.data || deptRes.data)) || []
      const doctors = (docRes?.data && (docRes.data.results || docRes.data.data)) || []
      const packages = (pkgRes?.data && (pkgRes.data.results || pkgRes.data.data)) || []
      const campaigns = (bannerRes?.data && (bannerRes.data.results || bannerRes.data.banners || bannerRes.data.data)) || []

      commit('SET_MASTER_ENTITIES', { departments, doctors, packages, campaigns })
    } finally {
      commit('SET_LOADING_ENTITIES', false)
    }
  },
  async saveNewsArticle({ commit }, { isEdit, id, payload }) {
    commit('SET_IS_LOADING', true)
    try {
      let res = null
      if (isEdit && id) {
        res = await client.secureHttpClient.put(`${pathUrl}/news/${id}`, payload)
      } else {
        res = await client.secureHttpClient.post(`${pathUrl}/news`, payload)
      }
      return res
    } finally {
      commit('SET_IS_LOADING', false)
    }
  },

  setCategoryPage({ commit }, page) {
    commit('SET_CATEGORY_PAGE', page)
  },
  setCategoryPageSize({ commit }, size) {
    commit('SET_CATEGORY_PAGE_SIZE', size)
  },
  async fetchCategoriesTable({ commit, state }) {
    commit('SET_CATEGORY_LOADING', true)
    try {
      let query = '?all_status=true&with_org=true'
      const orgs = (state.orgList && state.orgList.all && state.orgList.all.map(o => o.codename)) || []
      if (orgs.length > 0) {
        orgs.forEach((org, index) => {
          query += `&orgs[${index}]=${org}`
        })
      }

      const res = await client.secureHttpClient.get(`${pathUrl}/category${query}`)
      const raw = res?.data?.data || res?.data || []
      const list = Array.isArray(raw) ? raw : []

      const listWithCounts = await Promise.all(
        list.map(async cat => {
          try {
            const countRes = await client.secureHttpClient.get(`${pathUrl}/news`, {
              params: { category: cat.id, limit: 1, status: '' }
            })
            return {
              ...cat,
              total_articles: countRes?.data?.total !== undefined ? countRes.data.total : 0
            }
          } catch (e) {
            return { ...cat, total_articles: 0 }
          }
        })
      )

      commit('SET_CATEGORY_TABLE_LIST', listWithCounts)
      commit('SET_CATEGORY_TOTAL', listWithCounts.length)
      return listWithCounts
    } catch (err) {
      Vue.$log.error('fetchCategoriesTable error:', err)
      commit('SET_CATEGORY_TABLE_LIST', [])
      commit('SET_CATEGORY_TOTAL', 0)
      return []
    } finally {
      commit('SET_CATEGORY_LOADING', false)
    }
  },

  async createCategory({ dispatch }, payload) {
    const res = await client.secureHttpClient.post(`${pathUrl}/category`, payload)
    await dispatch('fetchCategoriesTable')
    return res
  },
  async updateCategory({ dispatch }, { id, data }) {
    const res = await client.secureHttpClient.put(`${pathUrl}/category/${id}`, data)
    await dispatch('fetchCategoriesTable')
    return res
  },
  async deleteCategory({ dispatch }, id) {
    const res = await client.secureHttpClient.delete(`${pathUrl}/category/${id}`)
    await dispatch('fetchCategoriesTable')
    return res
  },



}

// Mutations
const mutations = {
  SET_ORG_LIST(state, org) {
    state.orgObject = org.data
  },
  RESET_STATE(state) {
    state.newsObject = defaultState().newsObject
    state.orgList = defaultState().orgList
    state.duplicateId = defaultState().duplicateId
    state.isDisableAfterPublish = defaultState().isDisableAfterPublish
  },
  RESET_LIST_STATE(state) {
    state.filterStatus = defaultState().filterStatus
    state.filterCategory = defaultState().filterCategory
    state.textSearch = defaultState().textSearch
    state.currentPage = 1
    state.sortBy = defaultState().sortBy
    state.orgList = defaultState().orgList
  },
  SET_STYLE_CONTENT(state) {
    state.newsObject.contents[0].description = state.newsObject.contents[0].description
      .toString()
      .split('<img')
      .join('<img width="100%" height="auto"')
    state.newsObject.contents[1].description = state.newsObject.contents[1].description
      .toString()
      .split('<img')
      .join('<img width="100%" height="auto"')
  },
  SET_EDIT_MODE(state, isEdit) {
    state.isEditMode = isEdit
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_PAGE(state, page) {
    state.currentPage = page
  },
  SET_PAGE_SIZE(state, size) {
    state.pageSize = size
  },
  SET_CATEGORY(state, category) {
    const raw = category?.data || category || []
    const cats = Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : [])
    let results = cats.map(object => {
      const contents = object.category_contents || object.contents || []
      const th = contents.find(c => c.code === 'th')
      const en = contents.find(c => c.code === 'en')
      const title = (th && th.title) || (en && en.title) || contents[0]?.title || object.name || `Category ${object.id}`
      const isInactive = Number(object.status) === 1
      const label = isInactive ? `${title} (Inactive)` : title
      return { text: label, value: String(object.id) }
    })
    state.category = results
  },
  SET_FILTER_STATUS(state, status) {
    state.filterStatus = status
  },

  SET_FILTER_CATEGORY(state, status) {
    state.filterCategory = status
  },
  SET_TEXT_SEARCH(state, text) {
    state.textSearch = text
  },
  SET_TOTAL(state, total) {
    state.total = total
  },
  SET_NEWS_LIST(state, news) {
    state.newsList = news
  },
  SET_NEWS(state, pkg) {
    state.newsObject = { ...defaultState().newsObject, ...pkg }
    state.isDisableAfterPublish = moment(pkg.period_start_date).isSameOrBefore()

    const start = !pkg.period_start_date
      ? { dateString: null, timeString: '' }
      : splitToDateAndTime(pkg.period_start_date)
    state.newsObject.period_start_date = start.dateString
    state.newsObject.period_start_time = start.timeString
    const end = !pkg.period_end_date
      ? { dateString: null, timeString: '' }
      : splitToDateAndTime(pkg.period_end_date)
    state.newsObject.period_end_date = end.dateString
    state.newsObject.period_end_time = end.timeString
  },
  SET_FIELD_SORT(state, field) {
    state.sortBy = field
  },
  SET_SORT(state, sort) {
    state.sortDesc = sort
  },
  SET_UPDATE_ID(state, ids) {
    state.updateIdList = ids
  },
  SET_IMAGE_THAI(state, file) {
    convertFileToBase64(file)
      .then(base64 => {
        state.newsObject.contents[0].thumbnail = base64
      })
      .catch(e => {
        Vue.$log.error(e)
      })
  },
  SET_IMAGE_ENG(state, file) {
    convertFileToBase64(file)
      .then(base64 => {
        state.newsObject.contents[1].thumbnail = base64
      })
      .catch(e => {
        Vue.$log.error(e)
      })
  },
  SET_POPUP_DELETE(state, status) {
    state.isDelete = status
  },
  SET_DELETE_ID(state, id) {
    state.deleteId = id
  },
  SET_SHOW_PREVIEW(state, status) {
    state.isPreview = status
  },
  SET_ORG_FILTER_CATEGORY(state, status) {
    state.orgFilterCategory = status
  },
  SET_ORG_FILTER(state, org) {
    const raw = org?.data || org || []
    const list = Array.isArray(raw) ? raw : (raw && Array.isArray(raw.data) ? raw.data : [])
    const selected = []

    if (list.length === 1) {
      list.forEach(d =>
        selected.push({
          codename: d.codename,
          selected: true
        })
      )
    }
    state.orgList.selected = selected
    state.orgList.all = list
  },
  SET_PERIODS(state, data) {
    state.newsObject.period_start_date =
      data.period_start_date && convertDatePicker(data.period_start_date)
    state.newsObject.period_end_date =
      data.period_end_date && convertDatePicker(data.period_end_date)
  },
  SET_DUPLICATE_NEWS_ID(state, id) {
    state.duplicateId = id
  },
  SET_LOADING_ENTITIES(state, status) {
    state.isLoadingEntities = status
  },
  SET_MASTER_ENTITIES(state, payload = {}) {
    const rawDepts = payload.departments || payload.depts || []
    const rawDocs = payload.doctors || payload.docs || []
    const rawPkgs = payload.packages || payload.pkgs || []
    const rawBanners = payload.campaigns || payload.banners || []

    const departments = Array.isArray(rawDepts) ? rawDepts : (rawDepts.data || [])
    const doctors = Array.isArray(rawDocs) ? rawDocs : (rawDocs.results || rawDocs.data || [])
    const packages = Array.isArray(rawPkgs) ? rawPkgs : (rawPkgs.results || rawPkgs.data || [])
    const campaigns = Array.isArray(rawBanners) ? rawBanners : (rawBanners.results || rawBanners.banners || rawBanners.data || [])

    state.departmentList = departments.map(d => ({
      id: d.id || d.department_id,
      name: d.title || d.name || d.department_name || `Department #${d.id || d.department_id}`
    }))

    state.doctorList = doctors.map(doc => {
      let docName = doc.name || doc.doctor_name || `Doctor #${doc.id || doc.doctor_id}`
      if (doc.contents && doc.contents.length) {
        const c = doc.contents.find(i => i.code === 'th') || doc.contents[0]
        docName = `${c.prefix_name || ''} ${c.name || ''}`.trim()
      }
      return {
        id: doc.id || doc.doctor_id,
        name: docName,
        department: doc.department?.name || doc.department_name || '',
        department_id: doc.department?.id || doc.department_id || null,
        specialist: doc.specialist || ''
      }
    })

    state.packageList = packages.map(p => {
      const th = (p.contents || []).find(c => c.code === 'th') || p.contents?.[0] || {}
      return {
        id: p.id || p.package_id,
        name: th.title || p.title || p.name || p.package_name || `Package #${p.id || p.package_id}`
      }
    })

    state.campaignList = campaigns.map(b => {
      const th = (b.contents || []).find(item => item.code === 'th') || b.contents?.[0] || {}
      return {
        id: b.id || b.banner_id || b.campaign_id,
        name: th.title || b.title || b.name || b.banner_name || `Campaign #${b.id || b.banner_id || b.campaign_id}`
      }
    })
  },

  SET_CATEGORY_PAGE(state, page) {
    state.categoryCurrentPage = page
  },
  SET_CATEGORY_PAGE_SIZE(state, size) {
    state.categoryPageSize = size
  },
  SET_CATEGORY_TABLE_LIST(state, list) {
    state.categoryTableList = list
  },
  SET_CATEGORY_TOTAL(state, total) {
    state.categoryTotal = total
  },
  SET_CATEGORY_LOADING(state, status) {
    state.isCategoryLoading = status
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}